
import { defineComponent } from 'vue';
import config from '../constants/config';
import { googleTagManagerService } from '../services/GoogleTagManagerService';

export default defineComponent({
  name: 'ShareSiteBox',
  data() {
    return {
      domain: config.DOMAIN,
      sharing: {
        url: (window as never)['baseUrl'],
        title: '',
      },
      networks: [
        { network: 'email', name: 'Email', classObject: { 'button--email': true }, description: '' },
        { network: 'facebook', name: 'Facebook', classObject: { 'button--facebook': true }, description: '' },
        { network: 'whatsapp', name: 'WhatsApp', classObject: { 'button--whatsapp': true }, description: '' },
      ],
    };
  },
  created() {
    this.sharing.title = this.$t('ShareSiteBox.subject');
    this.networks[0].description = this.$t('ShareSiteBox.description', { domain: this.domain });
  },
  methods: {
    copyToClipboard(value) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(value);
      }
    },
    open() {
      googleTagManagerService.send({
        event: 'zdielat_click',
      });
    },
  },
});
